
import axios from "axios";

export const checkField = (field, state) => {
  if (["paypalClientId", "paypalClientSecret"].includes(field)) {
    return state.paypalMode ? "" : "none";
  }
  return "";
};

export const getData = (props, category, id) => {
  switch (category) {
    case "Admin":
      props.getOneUser(id);
      break;
    case "Customer":
      props.getOneCustomer(id);
      break;
    case "Provider":
      props.getOneProvider(id);
      break;
    case "Voucher":
      props.getOneVoucher(id);
      break;
    case "Product":
      props.getOneProduct(id);
      break;
    case "Category":
      props.getOnecategory(id);
      break;
    default:
      break;
  }
};

export const handleSubmit = async (props, category, id, values) => {
  // Validation logic here (omitted for brevity)

  const formData = new FormData();
  Object.keys(values).forEach((key) => {
    if (key === "PRFeedData") {
      if (Array.isArray(values[key])) {
        values[key].forEach((item) => formData.append("PRFeedData", JSON.stringify(item)));
      } else {
        formData.append("PRFeedData", JSON.stringify(values[key]));
      }
    } else {
      formData.append(key, values[key]);
    }
  });

  try {
    switch (category) {
      case "Admin":
        await props.updateUser(formData, { "Content-Type": "multipart/form-data" });
        break;
      case "Customer":
        await props.updateCustomer(formData, { "Content-Type": "multipart/form-data" });
        break;
      case "Provider":
        props.enableLoder();
        await props.updateProvider(formData, { "Content-Type": "multipart/form-data" });
        break;
      case "Voucher":
        await props.updateVoucher(formData, { "Content-Type": "multipart/form-data" });
        break;
      case "Product":
        await props.updateProduct(formData, { "Content-Type": "multipart/form-data" });
        break;
      default:
        break;
    }
  } catch (error) {
    console.error("Error updating data:", error);
  }
};

export const deleteProvider = async (providerId, navigate) => {
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/providers/deleteOneUser`, { id: providerId });
    navigate('/providers');
  } catch (error) {
    console.error("Error deleting provider:", error);
  }
};

